module.exports = __webpack_public_path__ + "img/portrait-048.6c3fa8ce.jpg";